import React from 'react'
import classNames from 'classnames'

const RadioControl = ({ active, className, disabled, label }) => {
  const baseClasses =
    'w-5 h-5 border border-[var(--color-Neutral-3)] rounded-full transition-colors duration-100 flex items-center justify-center before:content-[""] before:block before:w-1.5 before:h-1.5 before:rounded-full before:transition-colors before:duration-200 before:translate-z-[1px]'

  const styleClasses = classNames(baseClasses, {
    'border-[7px]': active,
    'border-[var(--color-Neutral-3)] bg-[var(--color-Neutral-4)]': active && disabled,
    'border-[var(--color-primary-pure)]': active && !disabled,
  })

  return (
    <div className={classNames('flex items-center gap-2', { 'opacity-[0.5]': disabled }, className)}>
      <div className={styleClasses} />
      {label != null && label !== '' ? <div>{label}</div> : null}
    </div>
  )
}

export default RadioControl
